import type { ArticleContent, LangCode } from "./types";
import { enArticles } from "./en";
import { plArticles } from "./pl";
import { esArticles } from "./es";
import { frArticles } from "./fr";

export interface ArticleMeta {
  slug: string;
  icon: string;
  image: string;
}

export const articleOrder: string[] = [
  "usfans-spreadsheet-guide",
  "usfans-review",
  "usfans-shipping-cost",
  "usfans-coupon",
  "usfans-warehouse",
  "usfans-legit",
  "usfans-safety",
  "usfans-qc",
  "usfans-sellers",
  "usfans-comparisons",
  "usfans-buying-guide",
];

export const articleMeta: ArticleMeta[] = [
  {
    slug: "usfans-spreadsheet-guide",
    icon: "ri-book-open-line",
    image: "https://readdy.ai/api/search-image?query=Neat%20desk%20with%20a%20laptop%20showing%20a%20colorful%20spreadsheet%20and%20a%20single%20sneaker%20and%20folded%20hoodie%20beside%20it%2C%20warm%20natural%20window%20light%2C%20clean%20minimal%20editorial%20scene%2C%20sage%20green%20and%20cream%20tones%2C%20focused%20and%20calm%20atmosphere&width=1200&height=800&seq=art-guide-1&orientation=landscape",
  },
  {
    slug: "usfans-review",
    icon: "ri-star-line",
    image: "https://readdy.ai/api/search-image?query=Product%20review%20concept%20with%20a%20smartphone%20displaying%20a%20five%20star%20rating%20next%20to%20a%20neat%20stack%20of%20folded%20clothing%20on%20a%20soft%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20composition%2C%20warm%20neutral%20tones&width=1200&height=800&seq=art-review-1&orientation=landscape",
  },
  {
    slug: "usfans-shipping-cost",
    icon: "ri-truck-line",
    image: "https://readdy.ai/api/search-image?query=A%20tidy%20cardboard%20parcel%20box%20with%20packing%20tape%20and%20a%20shipping%20label%20beside%20a%20small%20stack%20of%20folded%20clothes%20on%20a%20clean%20beige%20background%2C%20soft%20studio%20light%2C%20minimal%20logistics%20product%20photography%2C%20warm%20and%20airy%20composition&width=1200&height=800&seq=art-shipping-1&orientation=landscape",
  },
  {
    slug: "usfans-coupon",
    icon: "ri-coupon-line",
    image: "https://readdy.ai/api/search-image?query=A%20stylish%20discount%20tag%20with%20a%20hanging%20string%20and%20a%20folded%20coupon%20beside%20a%20small%20gift%20box%20on%20a%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimal%20promotional%20product%20photography%2C%20gentle%20shadows%20and%20fresh%20composition&width=1200&height=800&seq=art-coupon-1&orientation=landscape",
  },
  {
    slug: "usfans-warehouse",
    icon: "ri-store-line",
    image: "https://readdy.ai/api/search-image?query=Neatly%20organized%20warehouse%20shelves%20with%20stacked%20cardboard%20boxes%20and%20folded%20apparel%20in%20soft%20neutral%20tones%2C%20clean%20bright%20industrial%20lighting%2C%20minimal%20logistics%20photography%2C%20orderly%20and%20spacious%20composition&width=1200&height=800&seq=art-warehouse-1&orientation=landscape",
  },
  {
    slug: "usfans-legit",
    icon: "ri-shield-check-line",
    image: "https://readdy.ai/api/search-image?query=Concept%20of%20trust%20and%20verification%20with%20a%20green%20checkmark%20badge%20beside%20a%20neat%20folded%20shirt%20on%20a%20clean%20light%20background%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20composition%2C%20reassuring%20and%20clean%20aesthetic&width=1200&height=800&seq=art-legit-1&orientation=landscape",
  },
  {
    slug: "usfans-safety",
    icon: "ri-shield-line",
    image: "https://readdy.ai/api/search-image?query=Concept%20of%20online%20security%20with%20a%20padlock%20icon%20and%20a%20credit%20card%20beside%20a%20folded%20garment%20on%20a%20soft%20neutral%20background%2C%20clean%20minimal%20studio%20lighting%2C%20reassuring%20and%20calm%20composition%20with%20warm%20tones&width=1200&height=800&seq=art-safety-1&orientation=landscape",
  },
  {
    slug: "usfans-qc",
    icon: "ri-search-eye-line",
    image: "https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20inspecting%20the%20stitching%20of%20a%20folded%20shirt%20on%20a%20clean%20cream%20background%2C%20soft%20focused%20studio%20light%2C%20minimal%20quality%20control%20product%20photography%2C%20precise%20and%20clean%20composition&width=1200&height=800&seq=art-qc-1&orientation=landscape",
  },
  {
    slug: "usfans-sellers",
    icon: "ri-user-star-line",
    image: "https://readdy.ai/api/search-image?query=A%20small%20elegant%20storefront%20shelf%20with%20neatly%20folded%20apparel%20and%20a%20price%20tag%20hanging%20on%20a%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20minimal%20retail%20product%20photography%2C%20inviting%20and%20clean%20composition&width=1200&height=800&seq=art-sellers-1&orientation=landscape",
  },
  {
    slug: "usfans-comparisons",
    icon: "ri-scales-line",
    image: "https://readdy.ai/api/search-image?query=Two%20neatly%20folded%20shirts%20side%20by%20side%20in%20different%20colors%20with%20a%20simple%20comparison%20symbol%20between%20them%20on%20a%20clean%20light%20background%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20composition%2C%20clear%20and%20balanced%20aesthetic&width=1200&height=800&seq=art-compare-1&orientation=landscape",
  },
  {
    slug: "usfans-buying-guide",
    icon: "ri-shopping-cart-line",
    image: "https://readdy.ai/api/search-image?query=A%20minimal%20shopping%20cart%20with%20a%20folded%20hoodie%20and%20sneakers%20inside%20on%20a%20soft%20cream%20background%2C%20clean%20studio%20lighting%2C%20fresh%20e-commerce%20product%20photography%2C%20simple%20and%20inviting%20composition%20with%20warm%20tones&width=1200&height=800&seq=art-buying-1&orientation=landscape",
  },
];

export const articleContent: Record<LangCode, Record<string, ArticleContent>> = {
  en: enArticles,
  pl: plArticles,
  es: esArticles,
  fr: frArticles,
};

export function getArticle(
  slug: string,
  lang: string
): { meta: ArticleMeta; content: ArticleContent } | undefined {
  const code = (lang.split("-")[0] || "en") as LangCode;
  const contentMap = articleContent[code] || articleContent.en;
  const content = contentMap[slug];
  const meta = articleMeta.find((m) => m.slug === slug);
  if (!content || !meta) return undefined;
  return { meta, content };
}